export const REDACTED_VALUE = '[REDACTED]';

export const SENSITIVE_URL_PARAMS = [
  // Do not add kiosk api_key/key, qr_code, ticket_code, reservation_id, or
  // session_id here. Those values are operational join keys that must remain
  // visible in Sentry so ENTR scans, backend rows, and kiosk sessions can be
  // correlated during support incidents.
  'token',
  'secret',
  'password',
  'access_token',
  'refresh_token',
  'id_token',
  'client_secret',
] as const;

export const SENSITIVE_URL_PARAM_SET: ReadonlySet<string> = new Set(
  SENSITIVE_URL_PARAMS
);

const SENSITIVE_URL_PARAM_REGEX = new RegExp(
  `([?&](?:${SENSITIVE_URL_PARAMS.join('|')})=)[^&#\\s]*`,
  'gi'
);

export function redactSensitiveUrlParamValues(value: string): string {
  return value.replace(SENSITIVE_URL_PARAM_REGEX, `$1${REDACTED_VALUE}`);
}
